import clsx from 'clsx';

import BaseContainer from '@base/BaseContainer';

interface IHeaderShellProps {
    className?: string;
    mobileNav?: React.ReactNode;
    left: React.ReactNode;
    right: React.ReactNode;
}

const HeaderShell: React.FC<IHeaderShellProps> = ({ className, mobileNav, left, right }) => (
    <header className={clsx('h-20 bg-white border-b border-blueGray-200', className)}>
        <BaseContainer>
            <div className="relative flex items-stretch justify-between h-full">
                {mobileNav && <div className="h-full md:hidden">{mobileNav}</div>}
                <div className="flex items-stretch flex-1 h-full min-w-0">{left}</div>
                <div className="flex items-stretch h-full shrink-0">{right}</div>
            </div>
        </BaseContainer>
    </header>
);

export default HeaderShell;
